import React, { useEffect, useState } from "react";
import { BrowserView, isDesktop, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import MainLayout from "src/bepaid/layouts/MainLayout";

import Button from "src/bepaid/components/Form/controls/Button";

import ROUTES from "src/bepaid/routes";
import { history } from "src/ipm-shared/store";
import { useMakePaymentUrlParams } from "src/bepaid/pages/Payments/hooks";

import classnames from "classnames";
import styles from "./SelectPaymentMethodType.module.scss";
import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";
import { SUPPLIER_PAYOUT_TYPES } from "src/ipm-shared/store/model/PaymentRequest/const";
import { STORAGE_KEYS } from "src/ipm-shared/Utils/LocalStorage";
import { CHECKOUT_FORM } from "src/ipm-shared/store/model/Card/const";
import { FORM } from "src/ipm-shared/store/model/Payee/const";
import { purposeByEntity } from "src/bepaid/pages/Payments/const";

const View = (props: any) => {
  const { supplierPayoutType, setSupplierPayoutType, removeForm } = props;
  const { replaceRouteWithParams } = useMakePaymentUrlParams(
    ROUTES.PAYMENTS_CREATION
  );
  const selectedEntity = localStorage.getItem(
    STORAGE_KEYS.SELECTED_PAYMENT_ENTITY
  );
  const [loading, setLoading] = useState(false);

  const paymentMethodTypes = [
    {
      name: "Pay to UEN",
      description: "",
      entity: SUPPLIER_PAYOUT_TYPES.UEN
    },
    {
      name: "Pay to bank account ",
      description: "",
      entity: SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT
    }
  ];

  const moveForward = () => {
    setLoading(true); // ok

    setTimeout(() => {
      history.push(
        replaceRouteWithParams(ROUTES.PAYMENTS_CREATION, {
          newEntity: "supplier",
          newAction: "select"
        })
      );

      return;
    }, 500);
  };

  useEffect(() => {
    if (
      !FeatureGateUtil.verifyFeature(props.features, "PAY_TO_UEN_FLOW") ||
      !props.isSingaporeAccount
    ) {
      history.push(
        replaceRouteWithParams(ROUTES.PAYMENTS_CREATION, {
          newEntity: "entity",
          newAction: "select"
        })
      );
    }

    if (selectedEntity) {
      removeForm(CHECKOUT_FORM);
      removeForm(FORM);
      const purpose = purposeByEntity[selectedEntity];
      if (purpose) props.resetSelectedPayees(purpose);
    }
  }, []);

  const onBack = () => {
    setSupplierPayoutType(null);
    history.push(
      replaceRouteWithParams(ROUTES.PAYMENTS_CREATION, {
        newEntity: "entity",
        newAction: "select"
      })
    );
  };

  const renderContent = () => {
    return (
      <>
        <div
          className={classnames(styles.wrapper, {
            [styles.desktop]: isDesktop
          })}
        >
          <ul className={styles.list}>
            {paymentMethodTypes.map(
              ({ name, description, entity }, idx: number) => (
                <li
                  key={idx}
                  onClick={() => {
                    setSupplierPayoutType(entity);
                  }}
                  className={classnames({
                    [styles.selected]: entity === supplierPayoutType
                  })}
                >
                  <b>{name}</b>
                  <span>{description}</span>
                </li>
              )
            )}
          </ul>
        </div>
      </>
    );
  };

  const renderBtnSubmit = () => {
    return (
      <Button
        id={"ipaymy_btn_select_enterprise"}
        wrapperClassName={styles.wrapperButton}
        className={styles.button}
        onClick={moveForward}
        type="primary"
        htmlType="button"
        loading={!supplierPayoutType || loading}
      >
        {loading ? "Moving forward..." : "Move forward"}
      </Button>
    );
  };

  const renderDesktopView = () => {
    return (
      <DesktopModalLayout
        id={"ipaymy_select_payment_method_type"}
        title={"Select payment method"}
        onBack={onBack}
        onClose={props.onClose}
        maxWidth450={true}
        onSubmit={moveForward}
        btnSubmit={renderBtnSubmit()}
      >
        {renderContent()}
      </DesktopModalLayout>
    );
  };

  const renderMobileView = () => {
    return (
      <MainLayout
        id={"ipaymy_select_payment_method_type"}
        header={{
          title: "Select payment method",
          hideMenu: true,
          onClose: props.onClose
        }}
        footer={renderBtnSubmit()}
      >
        {renderContent()}
      </MainLayout>
    );
  };

  return (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
};

export default View;
